// @flow

import React from "react";
import { formatSequencial } from "@tvg/formatter";
import {
  ResultsTable,
  NumberIcon,
  AwaitingContainer,
  AwaitingLabel
} from "./styled-components";
import {
  Number,
  Position,
  RunnerRow
} from "../../_molecules/RacePayoffRunner/styled-components";

const PendingRunnerPayoffs = () => {
  const renderPendingRunner = (pos: number) => (
    <AwaitingContainer showBorder>
      <RunnerRow
        key={`position-runner-${pos}`}
        data-qa-label="raceResultsRunner-runner"
      >
        <Position data-qa-label="raceResultsRunner-runner-position">
          {formatSequencial(pos)}
        </Position>
        <Number>
          <NumberIcon>?</NumberIcon>
        </Number>
        <AwaitingLabel>Awaiting final result</AwaitingLabel>
      </RunnerRow>
    </AwaitingContainer>
  );

  return (
    <section data-qa-label="raceResults">
      <ResultsTable>
        {renderPendingRunner(1)}
        {renderPendingRunner(2)}
        {renderPendingRunner(3)}
      </ResultsTable>
    </section>
  );
};

export default PendingRunnerPayoffs;
